jQuery(document).ready(function (handler) {
    initializeSelectize(handler);
});
const initializeSelectize = (handler) => {
    handler("select[data-selectize-enabled='true']").each(function () {
        let $select = handler(this);
        //collecting all options that have the disabled attribute to pass to the disabled options plugin
        let disabledOpts = $select.find('option[disabled=""]');
        let values = [];
        //from the option tags, get all of the values associated with the disabled options. This will be used to filter the selection in the plugin
        disabledOpts.each(ind => {
            values[ind] = disabledOpts[ind].value;
        });
        //initialize the selectize object with the disable_options plugin
        $select.selectize({
            plugins: {
                'disable_options': {
                    disableOptions: values
                }
            }
        });
    });
};
